import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import block from 'bem-cn'

import { selectJackpotList } from 'features/jackpots/selectors'
import { selectLocaleDict } from 'features/locale/selectors'

import { mediaSize } from 'shared/style/var'

import JackpotsPolling from 'components/JackpotsPolling/JackpotsPolling'
import Slider from 'components/Slider'

import { JackpotItem } from './JackpotItem/JackpotItem'

import './Jackpots.scss'

const b = block('jackpots')

const Jackpots = () => {
  const jackpotList = useSelector(selectJackpotList, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).slots
  const isMobileOrTablet = useMediaQuery({ maxWidth: mediaSize.laptop })
  const isMobile = useMediaQuery({ maxWidth: mediaSize.mobile })

  const items = useMemo(
    () => jackpotList.map(t => <JackpotItem key={t.id} amount={t.amount} name={t.name} locale={locale} />),
    [jackpotList, locale],
  )

  return (
    <>
      <JackpotsPolling />
      {!!items.length &&
        (isMobileOrTablet ? (
          <div className={b({ slider: true })}>
            <Slider
              items={items}
              slidesToShow={isMobile ? 1 : 2.5}
              centeredSlides={isMobile}
              initialSlide={0}
              spaceBetween={16}
              autoplay
              infinite
              isWithPagination={false}
            />
          </div>
        ) : (
          <div className={b()}>{items}</div>
        ))}
    </>
  )
}

export default Jackpots
